import styled, { css, keyframes } from 'styled-components'

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-flex;
`

interface TooltipContentProps {
  $placement: 'top' | 'bottom' | 'left' | 'right'
  $maxWidth: number
}

const placementStyles = {
  top: css`
    bottom: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
  `,
  bottom: css`
    top: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
  `,
  left: css`
    right: calc(100% + 10px);
    top: 50%;
    transform: translateY(-50%);
  `,
  right: css`
    left: calc(100% + 10px);
    top: 50%;
    transform: translateY(-50%);
  `,
}

export const TooltipContent = styled.div<TooltipContentProps>`
  position: absolute;
  z-index: 10000;
  padding: 10px 14px;
  background: ${({ theme }) => theme.colors.background.primary};
  color: ${({ theme }) => theme.colors.text.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.5;
  font-weight: 500;
  white-space: normal;
  word-wrap: break-word;
  max-width: ${({ $maxWidth }) => $maxWidth}px;
  pointer-events: none;
  animation: ${fadeIn} 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.15),
    0 2px 4px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  ${({ $placement }) => placementStyles[$placement]}

  &::before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;

    ${({ $placement, theme }) => {
      const arrowColor = theme.colors.background.primary
      switch ($placement) {
        case 'top':
          return css`
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            border-width: 5px 5px 0 5px;
            border-color: ${arrowColor} transparent transparent transparent;
            filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.05));
          `
        case 'bottom':
          return css`
            bottom: 100%;
            left: 50%;
            transform: translateX(-50%);
            border-width: 0 5px 5px 5px;
            border-color: transparent transparent ${arrowColor} transparent;
            filter: drop-shadow(0 -1px 2px rgba(0, 0, 0, 0.05));
          `
        case 'left':
          return css`
            left: 100%;
            top: 50%;
            transform: translateY(-50%);
            border-width: 5px 0 5px 5px;
            border-color: transparent transparent transparent ${arrowColor};
            filter: drop-shadow(1px 0 2px rgba(0, 0, 0, 0.05));
          `
        case 'right':
          return css`
            right: 100%;
            top: 50%;
            transform: translateY(-50%);
            border-width: 5px 5px 5px 0;
            border-color: transparent ${arrowColor} transparent transparent;
            filter: drop-shadow(-1px 0 2px rgba(0, 0, 0, 0.05));
          `
      }
    }}
  }
`
